export default __webpack_public_path__ + "static/media/CNo.87-5.b787cb2e.jpg";